import { fromJS, Map } from 'immutable';
import { findPropertiesByScope } from '@pearsontechnology/aero-plugin-schema';

/* extracts scope from state */
export function decomposeState(schema, state /* js */) {
  const immutableState = fromJS(state);

  /* definition of scope properties from schema */
  const scopeProperties = findPropertiesByScope(schema);

  /* build scope object from state */
  let scope = Map();

  scopeProperties.forEach((propertyDescriptor) => {
    scope = scope.setIn(
      propertyDescriptor.path,
      immutableState.getIn(propertyDescriptor.path)
    );
  });

  return { scope: scope.toJS() };
}
